// list-state helper (tab-scoped).
// Stores JSON in `sessionStorage` under a namespaced key.
const DEFAULT_PREFIX = 'octava:list-state';

/** Build storage key: `${DEFAULT_PREFIX}:${key}`. */
export function listStateKey(key) {
  if (!key) return DEFAULT_PREFIX;
  return `${DEFAULT_PREFIX}:${key}`;
}

/** Convenience for per-route isolation: `route:<routeName>` */
export function listStateKeyForRouteName(routeName) {
  return listStateKey(`route:${routeName || 'unknown'}`);
}

/** Save  */
export function saveListState(storageKey, payload) {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(payload));
    return true;
  } catch (e) {
    return false;
  }
}

/** Load saved  */
export function loadListState(storageKey) {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return { ok: false };

    const payload = JSON.parse(raw);

    return { ok: true, payload };
  } catch (e) {
    return { ok: false };
  }
}

/** Clear saved */
export function clearListState(storageKey) {
  try {
    sessionStorage.removeItem(storageKey);
    return true;
  } catch (e) {
    return false;
  }
}